import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    refreshButton: { padding: 0, margin: '0px 0px 0px 12px' },
  });
